import React from 'react';
import image from '../images/image6.png';
import { TourGuideImage } from '../TourGuideImage';

export const Segment12 = () => (
    <TourGuideImage src={image} />
);